var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4700",
    "data-name": "Group 4700",
    transform: "translate(-1614 -810)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-desktop-1060046",
    transform: "translate(1606.331 799.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13081",
    "data-name": "Path 13081",
    d: "M35.271,14H11.658A1.576,1.576,0,0,0,10.1,15.558V31.82a1.576,1.576,0,0,0,1.558,1.558h8.4a5.287,5.287,0,0,1-1.22,3.049H17.553a.32.32,0,0,0-.339.339v1.287a.32.32,0,0,0,.339.339H29.444a.32.32,0,0,0,.339-.339V36.766a.32.32,0,0,0-.339-.339H28.021a5.206,5.206,0,0,1-1.22-3.049h8.876a1.576,1.576,0,0,0,1.558-1.558V15.931A1.982,1.982,0,0,0,35.271,14ZM29.106,37.715H17.892V37.1H29.106Zm-1.965-1.287H19.721a6.132,6.132,0,0,0,1.016-3.049H26.09A6.624,6.624,0,0,0,27.141,36.427Zm9.384-4.607a.9.9,0,0,1-.881.881H11.658a.9.9,0,0,1-.881-.881V15.558a.9.9,0,0,1,.881-.881H35.271a1.273,1.273,0,0,1,1.253,1.253Z",
    transform: "translate(0 0)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13082",
    "data-name": "Path 13082",
    d: "M38.7,20.2H16.039a.32.32,0,0,0-.339.339V34.632a.32.32,0,0,0,.339.339H38.7a.32.32,0,0,0,.339-.339V20.539A.364.364,0,0,0,38.7,20.2Zm-.339,14.093H16.378V20.878H38.364Z",
    transform: "translate(-3.703 -4.1)",
    stroke: "#000",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1319",
    "data-name": "Rectangle 1319",
    width: 32,
    height: 32,
    transform: "translate(1614 810)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIcon);
export default __webpack_public_path__ + "static/media/desktop-icon.d58eb603be898b85c7468bbdce9b24b2.svg";
export { ForwardRef as ReactComponent };